import React, { useState } from "react";
import ViewcCasetable from "../../../../library/custom/gridTable/GridTable";
import { TableLoader } from "../../../../library/common/Loader";
import DialogBox from "../../../../library/common/DialogBox";
import NORow from "../../../../library/custom/noRow/noRow";
import ReportRowManipulte from "../../../incidents/incidentList/ReportRowManipulte";
import "./contractor.scss";
import {
  ADMIN_CONTRACTOR_LIST,
  ADMIN_PERSONAL_CONTRACTOR,
} from "../../../../constant/routeContant";
import { useNavigate } from "react-router-dom";
import downloadIcon from "../../../../assets/downloadIcon.svg";
import Buttons from "../../../../library/custom/button/Button";
import { checkPrivileges } from "../../../../utils/rolesHelper";
import BackBtn from "../../../../library/custom/backBtn/backBtn";
import { IS_CONTRACTOR } from "../../../../constant/constant";
import { InactiveClient } from "../../../../utils/helper";

const ViewContractorDetails = ({
  addSubContractor,
  rows,
  personalContractorListData,
  loading,
  deleteList,
  compnayName,
  constractorId,
  sendEmail,
}) => {
  const navigate = useNavigate();
  const handleViewOnClick = () => { };
  const [openModal, setOpenModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState("");
  const dataBack = {
    title: "Back to Contractor List",
    route: ADMIN_CONTRACTOR_LIST,
  };

  const deletehandle = () => {
    if (InactiveClient()) return;
    setOpenModal(false);
    deleteList(selectedRow.id);
  };

  const handleEditClick = (prows) => {
    if (InactiveClient()) return;
    navigate(ADMIN_PERSONAL_CONTRACTOR, {
      state: {
        contractorId: constractorId,
        editMode: true,
        companyName: compnayName,
        contractorPersonnelId: prows.row.id,
        contractorData: rows,
      },
    });
  };

  const deleteContractors = (rows) => {
    if (InactiveClient()) return;
    setOpenModal(true);
    setSelectedRow(rows);
  };
  const columns = [
    { field: "personnelFirstName", headerName: "First Name", width: 200 },
    { field: "personnelLastName", headerName: "Last Name", flex: 2 },
    { field: "personnelPhone", headerName: "Contact", flex: 2 },
    { field: "personnelEmail", headerName: "Email", flex: 2 },

    {
      field: "",
      width: 170,
      sortable: false,
      disableClickEventBubbling: true,
      renderCell: (rows) => {
        return (
          <ReportRowManipulte
            rows={rows}
            viewOnClick={() => handleViewOnClick()}
            editOnClick={() => handleEditClick(rows)}
            deleteOnClick={() => deleteContractors(rows?.row)}
            edit={true}
            editLabel="Edit Personnel"
            download={false}
            viewLabel="View User"
            view={false}
            deleted={checkPrivileges([12, 43, 44, 145]) ? true : false}
            deleteLabel="Delete Personnel"
          />
        );
      },
    },
  ];

  return (
    <>
      {openModal && (
        <DialogBox
          open={openModal}
          rows={[]}
          deletehandle={deletehandle}
          handleCloseModal={() => setOpenModal(false)}
          view
        />
      )}
      {!IS_CONTRACTOR() && <BackBtn dataBack={dataBack} />}
      <div className="topBlockBody">
        <div className="contractorName">
          <div className="name"> Contractor Name</div>
          <div className="head"> {rows?.contractorName}</div>
        </div>
        <div className="contractorName">
          <div className="name">Contractor Grade</div>
          <div className="head">{rows?.grade}</div>
        </div>
        {checkPrivileges([12, 43, 44, 145, 146]) && (
          <Buttons
            id="btnAddPersonal"
            varientAddIconBlue={true}
            label={"Add Personnel"}
            onClick={(e) => addSubContractor(e)}
          />
        )}
      </div>
      <section className="grid_main_sec">
        <div className="grid_main_header two_grid">
          <div className="grid_heading_style">Personnel List</div>
          <div className="div-contractor-right-download" onClick={sendEmail}>
            <span>
              <img
                src={downloadIcon}
                className="DownLoadLogo"
                alt="DownLoad Logo"
              />
            </span>
            Download Data
          </div>
        </div>
      </section>
      <div className="desc_box row_uniq">
        <div className="table_style_ui">
          <ViewcCasetable
            getRowId={(r) => r.id}
            rows={personalContractorListData?.contractorsPersonnelData || []}
            rowCount={personalContractorListData?.noOfRecords}
            columns={columns}
            loading={loading}
            components={{
              LoadingOverlay: TableLoader,
              NoRowsOverlay: NORow,
            }}
            checkboxSelection={false}
            page="1"
            pagination
            pageSize={5}
            rowsPerPageOptions={[10, 20, 30]}
            backIconButtonProps={{ disabled: false }}
            disableSelectionOnClick
          />
        </div>
      </div>
    </>
  );
};

export default ViewContractorDetails;
